{
  "atoms.button.loading": "Načítava sa",
  "atoms.infobar.close": "Zavrieť informačný panel",
  "atoms.infobar.toggle": "Zobraziť viac informácií",
  "atoms.rich-text-editor.add-hard-break": "Nový riadok",
  "atoms.rich-text-editor.add-page-break": "Nová strana",
  "atoms.rich-text-editor.align-center": "Zarovnať na stred",
  "atoms.rich-text-editor.align-justify": "Zarovnať do bloku",
  "atoms.rich-text-editor.align-left": "Zarovnať doľava",
  "atoms.rich-text-editor.align-right": "Zarovnať doprava",
  "atoms.rich-text-editor.bold": "Tučné",
  "atoms.rich-text-editor.bullet-list": "Odrážkový zoznam",
  "atoms.rich-text-editor.colorize-green": "Zvýrazniť zelenou farbou",
  "atoms.rich-text-editor.colorize-orange": "Zvýrazniť oranžovou farbou",
  "atoms.rich-text-editor.colorize-purple": "Zvýrazniť fialovou farbou",
  "atoms.rich-text-editor.colorize-red": "Zvýrazniť červenou farbou",
  "atoms.rich-text-editor.colorize-yellow": "Zvýrazniť žltou farbou",
  "atoms.rich-text-editor.fullscreen": "Režim celej obrazovky",
  "atoms.rich-text-editor.heading1": "Nadpis 1",
  "atoms.rich-text-editor.heading2": "Nadpis 2",
  "atoms.rich-text-editor.heading3": "Nadpis 3",
  "atoms.rich-text-editor.heading4": "Nadpis 4",
  "atoms.rich-text-editor.italic": "Kurzíva",
  "atoms.rich-text-editor.lift-list-item": "Posunúť položku zoznamu o úroveň vyššie",
  "atoms.rich-text-editor.link": "Odkaz",
  "atoms.rich-text-editor.link.prompt": "Adresa URL",
  "atoms.rich-text-editor.ordered-list": "Číslovaný zoznam",
  "atoms.rich-text-editor.redo": "Znova",
  "atoms.rich-text-editor.sink-list-item": "Posunúť položku zoznamu o úroveň nižšie",
  "atoms.rich-text-editor.strike": "Prečiarknuté",
  "atoms.rich-text-editor.subscript": "Dolný index",
  "atoms.rich-text-editor.superscript": "Horný index",
  "atoms.rich-text-editor.underline": "Podčiarknuté",
  "atoms.rich-text-editor.undo": "Späť",
  "atoms.toast.close": "Zavrieť oznámenie",

  "breadcrumb.detail-error": "Nepodarilo sa načítať záznam",
  "breadcrumb.new": "Nový záznam",

  "combobox.remove-item.button": "Odstrániť položku",
  "combobox.remove-item.label": "Odstrániť {valueLabel}",
  "combobox.reset-button.label": "Obnoviť hodnotu",

  "common.no": "Nie",
  "common.yes": "Áno",

  "content-layout-group.abort-upload": "Zrušiť nahrávanie",
  "content-layout-group.download": "Stiahnuť",
  "content-layout-group.no-content": "Žiadne súbory",
  "content-layout-group.view": "Zobraziť",
  "content-layout-group.view-action.title": "Detail súboru",

  "data-form-preferences.cancel": "Zrušiť",
  "data-form-preferences.delete": "Vymazať",
  "data-form-preferences.delete.sucess.title": "Údaje boli úspešne odstránené.",
  "data-form-preferences.save": "Uložiť",
  "data-form-preferences.update.sucess.title": "Prehľad bol prepísaný aktuálnym nastavením",

  "data-form.auto-update.deleted": "Údaje, ktoré máte otvorené, boli v systéme odstránené iným používateľom.",
  "data-form.auto-update.not-refreshed": "Údaje boli v systéme aktualizované, zmeny sa však automaticky nenačítali, pretože formulár je v režime úpravy. Ak formulár uložíte, zmeny v systéme sa prepíšu. Ak chcete načítať aktuálne údaje, zatvorte formulár a znova ho otvorte.",
  "data-form.cancel": "Zrušiť",
  "data-form.close-button.tooltip": "Zavrieť panel",
  "data-form.confirm-dialog.subtitle": "Túto akciu nemožno vrátiť späť.",
  "data-form.confirm-dialog.title": "Záznam bude vymazaný",
  "data-form.delete": "Vymazať",
  "data-form.delete.error": "Nepodarilo sa odstrániť záznam.",
  "data-form.loading": "Načítava sa...",
  "data-form.new": "Nový",
  "data-form.preferences.active": "Aktívne",
  "data-form.refetch": "Načítať znova",
  "data-form.refetch-error": "Pri načítavaní údajov sa vyskytla chyba.",
  "data-form.refetch-success": "Údaje boli úspešne načítané.",
  "data-form.save": "Uložiť",
  "data-form.share": "Zdieľať",
  "data-form.submit.success.title": "Údaje boli úspešne uložené.",
  "data-form.submit.sucess.title": "Údaje boli úspešne odstránené.",
  "data-form.update": "Upraviť",

  "data-table.column-actions.copy": "Kopírovať hodnoty",
  "data-table.column-actions.copy-success": "Hodnoty boli skopírované",
  "data-table.column-actions.hide": "Skryť stĺpec",
  "data-table.columns": "Stĺpce",
  "data-table.create": "Pridať nový záznam",
  "data-table.default-title": "Evidencia",
  "data-table.document-preview-error": "Formát dokumentu je podporovaný, náhľad však nemožno zobraziť. Ak si chcete dokument prezrieť, stiahnite si ho.",
  "data-table.filter-close": "Zavrieť filtre",
  "data-table.filter-no-data": "Pre zvolené filtre sa nenašli žiadne položky.",
  "data-table.filter-reset-all": "Predvolené hodnoty",
  "data-table.filter-settings": "Nastavenia filtrov",
  "data-table.filter.date-from.label": "Od",
  "data-table.filter.date-to.label": "Do",
  "data-table.filter.no-value": "Žiadna hodnota",
  "data-table.filter.placeholder": "Pridať hodnotu",
  "data-table.filter.reset": "Obnoviť",
  "data-table.filters": "Filtre",
  "data-table.no-data": "Žiadne údaje",
  "data-table.open": "Otvoriť",
  "data-table.page-size": "Počet záznamov na stránke: ",
  "data-table.preference.delete": "Vymazať",
  "data-table.preferences-settings.fields.title": "Základné informácie",
  "data-table.preferences-settings.manage.title": "Správa prehľadov",
  "data-table.preferences.apply-profile": "Použiť nastavenie",
  "data-table.preferences.apply.message": "Prehľad bude nastavený ako aktuálny.",
  "data-table.preferences.columns.actions.label": "Akcie",
  "data-table.preferences.columns.actions.select-profile": "Použiť nastavenie",
  "data-table.preferences.columns.id.label": "Id",
  "data-table.preferences.columns.name.active": "Aktívne",
  "data-table.preferences.columns.name.label": "Názov",
  "data-table.preferences.delete.message": "Prehľad bude vymazaný. Túto akciu nemožno vrátiť späť.",
  "data-table.preferences.loading": "Načítava sa...",
  "data-table.preferences.manage": "Spravovať nastavenia",
  "data-table.preferences.no-data": "Žiadne údaje",
  "data-table.preferences.override": "Prepísať prehľad aktuálnym nastavením",
  "data-table.preferences.override.message": "Nastavenia prehľadu budú prepísané aktuálnymi nastaveniami tabuľky",
  "data-table.preferences.save-profile": "Uložiť nastavenie",
  "data-table.preferences.save-profile.name": "Názov nastavenia",
  "data-table.preferences.save-profile.success": "Prehľad bol úspešne uložený",
  "data-table.preferences.save-profile.title": "Uložiť nastavenie tabuľky",
  "data-table.preferences.select-profile": "Vybrať nastavenie",
  "data-table.refetch": "Načítať znova",
  "data-table.refetch-error": "Pri načítavaní údajov sa vyskytla chyba.",
  "data-table.refetch-success": "Údaje boli znova načítané.",
  "data-table.search": "Hľadať",
  "data-table.select-all": "Vybrať všetko",
  "data-table.select-row": "Vybrať riadok",
  "data-table.select-row.aria-label": "Vybrať riadok {label}",
  "data-table.settings": "Nastavenia",

  "dictionary-evidence.code": "Kód",
  "dictionary-evidence.valid-from": "Platnosť od",
  "dictionary-evidence.valid-to": "Platnosť do",

  "domain-evidence.audit-log": "Auditný záznam",
  "domain-evidence.created-at": "Dátum vytvorenia",
  "domain-evidence.created-by": "Vytvoril",
  "domain-evidence.modified-at": "Dátum úpravy",
  "domain-evidence.modified-by": "Upravil",

  "error.details": "Podrobnosti:",
  "error.loading-me": "Pri načítavaní údajov o používateľovi nastala chyba. Skúste stránku znova načítať. Ak problém pretrváva, kontaktujte podporu.",
  "error.status": "Stavový kód: {status} – {code}",
  "error.timestamp": "Dátum a čas: {date}",

  "evidence.layout.buttons.close-detail.text": "Zavrieť detail",

  "file-download-button.download": "Stiahnuť",
  "file-download-button.download-success": "Súbor bol stiahnutý",

  "file-input-layout-group.view": "Zobraziť",
  "file-input-layout-group.view-action.title": "Detail súboru",

  "file-input.trigger": "Vybrať súbor",

  "file-upload.max-files-exceeded": "Maximálny počet súborov ({max}) bol prekročený.",

  "form-table.add-record": "Pridať záznam",
  "form-table.add-record.row": "Pridať riadok",
  "form-table.no-records": "Žiadne záznamy",
  "form-table.remove-record-content": "Chcete odstrániť tento riadok?",
  "form-table.remove-record-title": "Odstrániť riadok",
  "form-table.remove-record-tooltip": "Odstrániť riadok",

  "form.file-upload.abort": "Zrušiť nahrávanie",

  "input.reset": "Obnoviť pôvodnú hodnotu",

  "molecules.autocomplete.loading": "Načítava sa...",
  "molecules.autocomplete.no-data": "Žiadne údaje",
  "molecules.combobox.isFetching": "Načítava sa...",
  "molecules.combobox.min-query-length-message": "Minimálny počet znakov je {minQueryLength}.",
  "molecules.combobox.no-data": "Žiadne údaje",
  "molecules.confirm.cancel": "Zavrieť",
  "molecules.confirm.confirm": "Potvrdiť",
  "molecules.pagination.gotoPage": "Prejsť na stranu: {page}",

  "navigation.logout": "Odhlásiť sa",

  "pdf.download": "Stiahnuť",
  "pdf.next-page": "Nasledujúca strana",
  "pdf.prev-page": "Predchádzajúca strana",
  "pdf.rotate-ccw": "Otočiť proti smeru hodinových ručičiek",
  "pdf.rotate-cw": "Otočiť v smere hodinových ručičiek",
  "pdf.view": "Zobrazenie",
  "pdf.view-one-page": "Jedna strana",
  "pdf.view-vertical-scroll": "Vertikálne posúvanie",
  "pdf.zoom-in": "Priblížiť",
  "pdf.zoom-out": "Oddialiť",

  "permission-guard.unauthorized": "Stránka sa nenašla.",

  "remove-file-action.delete": "Odstrániť",

  "rich-text-editor.placeholder": "Začnite písať...",

  "sentry.buttons.homapage.text": "Späť na nástenku",
  "sentry.user.description.text": "Ospravedlňujeme sa, ale na serveri došlo k neočakávanej chybe.",
  "sentry.user.error-id": "ID chyby:",
  "sentry.user.error-message.text": "Na odstránení chyby už pracujeme. Pri ďalšej komunikácii s podporou uveďte nasledujúce číslo chyby.",
  "sentry.user.title": "Chyba servera",

  "sidebar.close-menu.label": "Zavrieť menu",
  "sidebar.open-menu.label": "Otvoriť menu",

  "titled-evidence.columns.description": "Popis",
  "titled-evidence.columns.title": "Názov",
  "titled-evidence.description": "Popis",
  "titled-evidence.layout-title": "Základné informácie",
  "titled-evidence.title": "Názov",

  "validation/array.exact": "Musí obsahovať presne {value} prvkov",
  "validation/array.too_big.exclusive": "Musí obsahovať menej ako {value, plural, =1 {jeden prvok} =2 {dva prvky} =3 {tri prvky} =4 {štyri prvky} other {# prvkov}}",
  "validation/array.too_big.inclusive": "Môže obsahovať najviac {value, plural, =1 {jeden prvok} =2 {dva prvky} =3 {tri prvky} =4 {štyri prvky} other {# prvkov}}",
  "validation/array.too_small.exclusive": "Musí obsahovať viac ako {value, plural, =1 {jeden prvok} =2 {dva prvky} =3 {tri prvky} =4 {štyri prvky} other {# prvkov}}",
  "validation/array.too_small.inclusive": "Musí obsahovať aspoň {value, plural, =1 {jeden prvok} =2 {dva prvky} =3 {tri prvky} =4 {štyri prvky} other {# prvkov}}",
  "validation/date.exact": "Musí byť presne {value}",
  "validation/date.invalid_date": "Neplatný dátum",
  "validation/date.too_big.exclusive": "Musí byť pred {value}",
  "validation/date.too_big.inclusive": "Môže byť najviac {value}",
  "validation/date.too_small.exclusive": "Musí byť po {value}",
  "validation/date.too_small.inclusive": "Musí byť aspoň {value}",
  "validation/default": "Neplatný vstup",
  "validation/number.exact": "Musí byť presne {value}",
  "validation/number.not_multiple_of": "Musí byť násobkom {value}",
  "validation/number.too_big.exclusive": "Musí byť menší ako {value}",
  "validation/number.too_big.inclusive": "Môže byť najviac {value}",
  "validation/number.too_small.exclusive": "Musí byť väčší ako {value}",
  "validation/number.too_small.inclusive": "Musí byť aspoň {value}",
  "validation/string.exact": "Musí obsahovať presne {value, plural, =1 {jeden znak} =2 {dva znaky} =3 {tri znaky} =4 {štyri znaky} other {# znakov}}",
  "validation/string.invalid.datetime": "Neplatný dátum",
  "validation/string.invalid.email": "Neplatná e-mailová adresa",
  "validation/string.invalid.endsWith": "Musí sa končiť na {value}",
  "validation/string.invalid.regex": "Neplatný formát",
  "validation/string.invalid.startsWith": "Musí sa začínať na {value}",
  "validation/string.invalid.url": "Neplatná URL",
  "validation/string.required": "Povinné pole",
  "validation/string.too_big.exclusive": "Musí obsahovať menej ako {value, plural, =1 {jeden znak} =2 {dva znaky} =3 {tri znaky} =4 {štyri znaky} other {# znakov}}",
  "validation/string.too_big.inclusive": "Môže obsahovať najviac {value, plural, =1 {jeden znak} =2 {dva znaky} =3 {tri znaky} =4 {štyri znaky} other {# znakov}}",
  "validation/string.too_small.exclusive": "Musí obsahovať viac ako {value, plural, =1 {jeden znak} =2 {dva znaky} =3 {tri znaky} =4 {štyri znaky} other {# znakov}}",
  "validation/string.too_small.inclusive": "Musí obsahovať aspoň {value, plural, =1 {jeden znak} =2 {dva znaky} =3 {tri znaky} =4 {štyri znaky} other {# znakov}}",
  "validation/type.invalid": "Neplatný typ. Očakávané \"{expected}\", nájdené \"{received}\"",
  "validation/type.required": "Povinné pole"
}
